import { render, staticRenderFns } from "./StickyMenu.vue?vue&type=template&id=ce993fe8&scoped=true"
import script from "./StickyMenu.vue?vue&type=script&lang=ts"
export * from "./StickyMenu.vue?vue&type=script&lang=ts"
import style0 from "./StickyMenu.vue?vue&type=style&index=0&id=ce993fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce993fe8",
  null
  
)

export default component.exports